import { ApolloError, useApolloClient, useMutation } from '@apollo/client';
import { useRouter } from 'next/navigation';

import {
  SignInMutation,
  SignInMutationVariables
} from '@/__generated_graphql__/graphql';
import { ROUTES } from '@/constants/common';
import { SIGN_OUT } from '@/graphql/mutations/auth.mutations';
import { useGraphQLErrorProcessor } from '@/hooks/useGraphQLErrorProcessor';
import { useLoader } from '@/providers/LoaderProvider';
import { CookiesUtils } from '@/utils/helpers/cookies';

export const useSignOut = () => {
  const client = useApolloClient();

  const { showLoader, hideLoader } = useLoader();
  const handleGraphQLErrors = useGraphQLErrorProcessor();
  const { push } = useRouter();

  const [signOut] = useMutation<SignInMutation, SignInMutationVariables>(
    SIGN_OUT,
    {
      onCompleted() {
        client.cache.evict({
          id: 'ROOT_QUERY',
          fieldName: 'profile'
        });
        client.cache.gc();
      }
    }
  );

  const handleSignout = async () => {
    try {
      showLoader();
      await signOut();
      CookiesUtils.logout();
      hideLoader();
      push(ROUTES.LOGIN);
    } catch (error) {
      handleGraphQLErrors({ error: error as ApolloError });
    }
  };

  return handleSignout;
};
